var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card", on: { click: _vm.goCarteira } }, [
    _c("div", { staticClass: "carteira" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Carteira T01")]),
      _c("span", { staticClass: "descricao" }, [_vm._v(_vm._s(_vm.data.title))])
    ]),
    _c(
      "div",
      {
        staticClass: "participacao",
        attrs: { title: _vm.data.percentege * 100 }
      },
      [
        _c("span", { staticClass: "titulo" }, [
          _vm._v("Participação carteira")
        ]),
        _c("span", { staticClass: "descricao" }, [
          _vm._v(
            _vm._s(
              _vm.bound
                ? "---"
                : _vm.percentageHelper.formatPercentage(_vm.data.percentege)
            )
          )
        ])
      ]
    ),
    _c("div", { staticClass: "emissor" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Emissor/Gestor")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.data.emissor))
      ])
    ]),
    _c("div", { staticClass: "custodiante" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Custodianate")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.data.custodiante))
      ])
    ]),
    _c("div", { staticClass: "liquidez" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Liquidez em dias")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.data.liquidez))
      ])
    ]),
    _c("div", { staticClass: "vencimento" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Vencimento")]),
      _c("span", { staticClass: "descricao" }, [
        _vm._v(_vm._s(_vm.dateHelper.formatDate(_vm.data.vencimento)))
      ])
    ]),
    _c("div", { staticClass: "saldo" }, [
      _c("span", { staticClass: "titulo" }, [_vm._v("Saldo Bruto")]),
      _c("span", { staticClass: "descricao" }, [_vm._v(_vm._s(_vm.data.value))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }